import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import CommonTable from '../../../../components/common-table/CommonTable';
import ProjectsTableItem from './ProjectsTableItem';
import Tr from '../../../../components/common-table/components/Tr';
import Th from '../../../../components/common-table/components/Th';
import { enableProjectToCompany, removeProjectFromCompany } from '../../../../redux/customers/customersActions';
import { MODAL_TYPES } from '../../../../constants';
import ConfirmationModal from '../../../../components/confirmation-modal/ConfirmationModal';
import DeleteLabel from '../../../../projects/projects-list/components/DeleteLabel';

import scss from './ProjectsTable.module.scss';

function ProjectsTable() {
  const { t } = useTranslation('customers');
  const dispatch = useDispatch();

  const { id: companyId } = useParams();

  const [selectedProject, seSelectedProject] = useState(null);
  const companyProjects = useSelector((state) => state.customers.customerInfo?.companyProjects) || [];

  const handleEnableCompanyProject = ({ projectId, enabled }) => {
    dispatch(enableProjectToCompany({ projectId, enabled, companyId }));
  };

  const handleOpenDeleteModal = (project) => {
    seSelectedProject({ ...project, modalType: MODAL_TYPES.DELETE });
  };

  const handleClearSelectedProject = () => {
    seSelectedProject(null);
  };

  const handleRemoveProject = () => {
    dispatch(removeProjectFromCompany({ companyId, projectId: selectedProject.projectId }));
    handleClearSelectedProject();
  };

  return (
    <div className={scss.tableWrapper}>
      <CommonTable
        content={companyProjects}
        renderBody={(data) => (
          <ProjectsTableItem
            key={data.projectId}
            data={data}
            onEnable={handleEnableCompanyProject}
            onDelete={handleOpenDeleteModal}
          />
        )}>
        <Tr>
          <Th isLeft>{t('name')}</Th>
          <Th isLeft>
            <span>
              {t('activated')} {' / '}
              <span className={scss.cellDeactivated}>{t('deactivated')}</span>
            </span>
          </Th>
          <Th isLeft>
            <span>
              {t('activated')} {' / '}
              <span className={scss.cellDeactivated}>{t('deactivated')}</span> {t('by')}
            </span>
          </Th>
          <Th isLeft extraClasses={scss.cellLastUsage}>
            {t('lastUsage')}
          </Th>
          <Th extraClasses={scss.cellEnable}>{t('enabled')}</Th>
          <Th isLeft extraClasses={scss.cellAction}>
            {t('actions')}
          </Th>
        </Tr>
      </CommonTable>

      <ConfirmationModal
        isOpen={selectedProject?.modalType === MODAL_TYPES.DELETE}
        onClose={handleClearSelectedProject}
        onCancel={handleClearSelectedProject}
        onConfirm={handleRemoveProject}
        subLabel={<DeleteLabel name={selectedProject?.projectName} />}
      />
    </div>
  );
}

export default ProjectsTable;
